import { getWorkflow as getWorkflowCommon } from '@jira/project-settings__workflow-services-document/src/getApiPrefix.tsx';
import { getApiPrefix } from './utils.tsx';
import { transformAPIToMetaDocument } from './transformer.tsx';

// TODO I am going to clean this up in a follow up PR
// can be removed with clean up of 'hix-6586_support_wfe_no_nav_or_sidebar_route' as has moved to a shared package
export const constructEndpoint = (cloudId: string) =>
	`/${getApiPrefix()}/query/${cloudId}/3/workflow`;

type WorkflowIdentifier = {
	workflowId?: string;
	workflowName?: string;
	projectAndIssueType?: {
		projectId: string;
		issueTypeId: string;
	};
};

export type GetWorkflowConfigOptions = { checkForDrafts: boolean };

const getWorkflow = async (
	cloudId: string,
	workflowIdentifier: WorkflowIdentifier,
	config?: GetWorkflowConfigOptions,
) => {
	const result = await getWorkflowCommon(cloudId, workflowIdentifier, config);
	return transformAPIToMetaDocument(result);
};

export default getWorkflow;
